import React from "react";
import { CheckIcon, CreditCardIcon, MailIcon, PrinterIcon, StarIcon } from "lucide-react";
import { CheckoutButton } from "./CheckoutButton";
import { ctaSubline, heroChecklist, heroImage, heroQuotes, heroTrust } from "../data/content";
const trustIcons = [MailIcon, PrinterIcon, CreditCardIcon];
export function Hero() {
  return <section className="px-4 pb-14 pt-10 text-center sm:px-5 sm:pb-20 sm:pt-16" data-id="element-101" data-mp="4na06ozlls6c">
      <p className="flex items-center justify-center gap-3 text-[10px] font-semibold tracking-[0.2em] text-gold sm:gap-4 sm:text-sm sm:tracking-[0.3em]" data-id="element-102" data-mp="128fnvds7g3t2">
        <span className="hidden h-px w-8 bg-gold sm:block" aria-hidden data-id="element-103" data-mp="sbb0jammi2ao" />
        LA MÉTHODE COMPLÈTE POUR PROFESSEURS DE GUITARE
      </p>
      <h1 className="mx-auto mt-5 max-w-5xl font-display text-[40px] uppercase leading-[0.95] text-cream sm:mt-6 sm:text-7xl lg:text-[84px]" data-id="element-104" data-mp="nb6llp1d5fmk">
        Tout votre trimestre de cours de guitare,
        <span className="block text-gold" data-id="element-105" data-mp="3825wklpczzj9">prêt à enseigner.</span>
      </h1>
      <p className="mx-auto mt-5 max-w-2xl font-serif text-lg italic leading-relaxed text-mute sm:mt-7 sm:text-2xl" data-id="element-106" data-mp="3j8selyn99fos">
        Un livre théorique, un livre pratique et 5 bonus offerts pour organiser vos cours, expliquer les notions essentielles et passer à la pratique avec vos élèves.
      </p>

      <div className="relative mx-auto mt-10 max-w-4xl rounded-2xl border border-line bg-panel p-2 sm:mt-12 sm:rounded-3xl sm:p-4" data-id="element-107" data-mp="3e960lmzlrvex">
        <span className="absolute -top-3.5 right-4 z-10 rounded-full bg-gold px-3 py-1 text-[11px] font-bold tracking-widest text-ink sm:-top-4 sm:right-6 sm:px-4 sm:py-1.5 sm:text-sm" data-id="element-108" data-mp="30gzvcvxzn8u9">
          2 LIVRES + 5 BONUS OFFERTS
        </span>
        <img src={heroImage} alt="Le pack : le livre théorique, le livre pratique et les 5 bonus offerts" className="w-full rounded-xl sm:rounded-2xl" data-id="element-109" data-mp="2qhqv5lcj4xzg" />
      </div>

      <CheckoutButton className="mt-8 w-full sm:mt-10 sm:w-auto" data-id="element-110" data-mp="2hl9puyqujubm" />
      <p className="mx-auto mt-3 max-w-md text-xs text-mute sm:max-w-none sm:text-sm" data-id="element-111" data-mp="2ljgzzaqt1xdu">{ctaSubline}</p>

      <ul className="mx-auto mt-6 flex max-w-2xl flex-col items-center justify-center gap-2 text-sm text-cream sm:flex-row sm:gap-6" data-id="element-112" data-mp="s3mcg0c5huxb">
        {heroTrust.map((t, i) => {
        const Icon = trustIcons[i];
        return <li key={t} className="flex items-center gap-2" data-id="element-113" data-mp="i9vqb23hxwks" data-mpi={i}>
              <Icon className="h-4 w-4 text-gold" aria-hidden data-id="element-114" data-mp="degdmdh866py" />
              {t}
            </li>;
      })}
      </ul>

      <ul className="mx-auto mt-10 grid max-w-2xl gap-x-8 gap-y-3 text-left sm:grid-cols-2" data-id="element-115" data-mp="1ayt710s27lbf">
        {heroChecklist.map(item => <li key={item} className="flex items-center gap-3 text-cream" data-id="element-116" data-mp="1126owjr4b8d3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold text-ink" data-id="element-117" data-mp="114kjyslsskkn">
              <CheckIcon className="h-4 w-4" aria-hidden data-id="element-118" data-mp="3lsp1j88sy9bs" />
            </span>
            {item}
          </li>)}
      </ul>

      <div className="mx-auto mt-12 grid max-w-5xl gap-4 text-left md:grid-cols-3" data-id="element-119" data-mp="3hqahwlxb75jg">
        {heroQuotes.map(q => <figure key={q.author} className="flex flex-col rounded-2xl border border-line bg-panel p-5" data-id="element-120" data-mp="1xavy8m3b8c8b">
            <div className="flex gap-0.5 text-gold" aria-label="5 étoiles sur 5" data-id="element-121" data-mp="21bfxpwbcvrxm">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden data-id="element-122" data-mp="2b0fwbely4lba" data-mpi={i} />)}
            </div>
            <blockquote className="mt-3 font-serif italic leading-relaxed text-cream" data-id="element-123" data-mp="2g0c1hh6dqisf">« {q.quote} »</blockquote>
            <figcaption className="mt-auto pt-4 text-xs font-bold tracking-wider text-gold" data-id="element-124" data-mp="2kxubzc01p62j">{q.author}</figcaption>
          </figure>)}
      </div>
    </section>;
}